import {connect} from 'react-redux';

import {State} from '../../../redux/reducer';
import LoginDialog from './LoginDialog';
import {loginSelectors} from '../redux';

const mapStateToProps = (state: State) => ({
   userName: loginSelectors.userName(state),
   isAuthenticated: loginSelectors.isAuthenticated(state),
});

export default connect(mapStateToProps, null)(LoginDialog);
